import { Action } from 'redux';

import ActionPayloadString from '../interfaces/actions/ActionPayloadString';

import * as Const from '../constants';

export const fetchPasswordSuccess = (text: string): ActionPayloadString => {
  return {
    type: Const.PASSWORD_RECEIVE_SUCCESS,
    payload: text,
  };
};

export const fetchPasswordError = (): Action => {
  return {
    type: Const.PASSWORD_RECEIVE_FAIL,
  };
};

export const fetchPasswordInit = (): Action => {
  return {
    type: Const.PASSWORD_RECEIVE_INIT,
  };
};

export const passwordTypePassword = (): Action => {
  return {
    type: Const.PASSWORD_TYPE_PASSWORD,
  };
};

export const passwordTypeText = (): Action => {
  return {
    type: Const.PASSWORD_TYPE_TEXT,
  };
};
